import { render, staticRenderFns } from "./UserShop.vue?vue&type=template&id=656ca170&"
import script from "./UserShop.vue?vue&type=script&lang=js&"
export * from "./UserShop.vue?vue&type=script&lang=js&"
import style0 from "./UserShop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports